import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { LabView } from "./LabView";
import { DEFAULT_DIRECTOR, labBasePath, type DirectorState } from "./types";

export function LabApp() {
  const location = useLocation();
  const navigate = useNavigate();
  const [director, setDirector] = useState<DirectorState>(DEFAULT_DIRECTOR);
  const basePath = labBasePath(location.pathname);

  const onDirector = useCallback((patch: Partial<DirectorState>) => {
    setDirector((current) => ({ ...current, ...patch }));
  }, []);

  const onTraverse = useCallback(
    (href: string) => {
      navigate(href);
    },
    [navigate],
  );

  return (
    <LabView
      search={location.search}
      basePath={basePath}
      director={director}
      onDirector={onDirector}
      onTraverse={onTraverse}
    />
  );
}
